import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "CompanyMapMarker",
  data() {
    return {
      mapInstance: null, // 地图实例
      // 公司信息配置（可根据实际需求修改）
      companyConfig: {
        key: "7594ee48cca6231bd1cd9bc07fead77d", // 你的高德Key
        lng: 121.376, // 经度
        lat: 31.21, // 纬度
        name: "上海曜宁信息科技有限公司", // 公司名称
        address: "上海市长宁区泉口路17号502室", // 可选：详细地址
      },
      // 地图基础配置
      mapConfig: {
        version: "2.0",
        zoom: 16.5, // 缩放级别（数值越大越清晰）
        plugins: [
          "AMap.Scale",
          "AMap.ToolBar",
          "AMap.Marker",
          "AMap.InfoWindow",
        ],
      },
    };
  },
  mounted() {
    // 确保DOM渲染完成后初始化地图
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    // 销毁地图实例，避免内存泄漏
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
    }
  },
  methods: {
    /**
     * 初始化地图并添加公司标记点
     */
    async initMap() {
      try {
        // 加载高德地图核心对象
        const AMap = await AMapLoader.load({
          key: this.companyConfig.key,
          version: this.mapConfig.version,
          plugins: this.mapConfig.plugins,
        });

        // 1. 初始化地图
        this.mapInstance = new AMap.Map("map-container", {
          resizeEnable: true,
          zoom: this.mapConfig.zoom,
          center: [this.companyConfig.lng, this.companyConfig.lat],
          mapStyle: "amap://styles/normal",
          loadTileWhileAnimating: true,
        });
        this.mapInstance.on("complete", () => {
          console.log("地图底图加载完成");
        });

        // 添加基础控件（比例尺、缩放按钮）
        this.mapInstance.addControl(new AMap.Scale());
        this.mapInstance.addControl(
          new AMap.ToolBar({
            position: "RB", // 缩放工具栏放在右下角
          })
        );

        // this.markerInstance = new AMap.Marker({
        //   position: [this.companyConfig.lng, this.companyConfig.lat],
        //   map: this.mapInstance, // 绑定到地图实例
        //   icon: new AMap.Icon({
        //     size: new AMap.Size(32, 32), // 标记点大小
        //     image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png", // 高德默认标记图标
        //     imageSize: new AMap.Size(32, 32),
        //   }),
        //   anchor: "bottom-center", // 锚点在底部中心
        // });

        // 创建信息窗体
        this.infoWindowInstance = new AMap.InfoWindow({
          content: `
            <div style="padding: 10px; font-size: 14px; min-width: 200px;">
              <h3 style="margin: 0 0 5px 0; color: #333; font-size: 16px;">${this.companyConfig.name}</h3>
              <p style="margin: 0; color: #666; line-height: 1.5;">地址：${this.companyConfig.address}</p>
            </div>
          `,
          offset: new AMap.Pixel(0, -40),
          closeWhenClickMap: false,
        });

        // 打开信息窗体
        this.infoWindowInstance.open(this.mapInstance, [
          this.companyConfig.lng,
          this.companyConfig.lat,
        ]);

        console.log("地图初始化成功，公司标记点已添加");
      } catch (error) {
        console.error("地图加载失败：", error);
        // 可选：给用户提示
        // this.$message.error("地图加载失败，请刷新重试");
      }
    },
  },
};
